import React, { useState } from "react";
import { Select, Button, Tag } from "antd";

import { EditOutlined } from "@ant-design/icons";

const filter = (input, option) => option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0;

const EditableSelectValue = (props) => {
    const [edit, setEdit] = useState(false);

    const onEditMode = () => setEdit(!edit);
    const onEditModeTag = (e) => {
        e.preventDefault();
        setEdit(!edit);
    };

    if (edit && props.allowEdit) {
        return (
            <Select
                data-testid="select"
                size="small"
                showSearch
                allowClear={!props.disableClear}
                defaultValue={props.defaultValue}
                style={{ width: 200 }}
                onChange={(id) => {
                    props.onChange(id);
                    setEdit(false);
                }}
                placeholder={props.placeholder}
                filterOption={filter}
                options={props.options}
                disabled={props.disabled}
            />
        );
    }

    if (props.tagMode) {
        return (
            <Tag
                closable
                onClose={onEditModeTag}
                closeIcon={props.icon ? props.icon : <EditOutlined />}
                color={props.color}
            >
                {props.defaultName}
            </Tag>
        );
    }

    if (props.allowEdit) {
        return (
            <Button data-testid="button" size="small" type="dashed" disabled={props.disabled} onClick={onEditMode}>
                {props.defaultName} {props.icon ? props.icon : <EditOutlined />}
            </Button>
        );
    }
    return (
        <Button data-testid="button" size="small" type="dashed" onClick={onEditMode}>
            {props.defaultName}
        </Button>
    );
};

export default EditableSelectValue;
